/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum ccTouchEvent
{
    TOUCH_START,
    TOUCH_END,
    TOUCH_MOVE,
    TOUCH_CANCEL
}

const ccTouchEventNames: any =
{
    TOUCH_START : cc.Node.EventType.TOUCH_START,
    TOUCH_END: cc.Node.EventType.TOUCH_END,
    TOUCH_MOVE: cc.Node.EventType.TOUCH_MOVE,
    TOUCH_CANCEL: cc.Node.EventType.TOUCH_CANCEL
};

// tslint:disable-next-line:class-name
export class ccTouchEventHelper
{
    public static GetEventName(event: ccTouchEvent): string
    {
        return ccTouchEventNames[ccTouchEvent[event]];
    }
}
